/* eslint-disable no-unused-vars */
import { Text1, Text2, Text6, skinVars } from '@telefonica/mistica';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatTimeConsumption } from '../../utils/dataTransformation/unitsConversion';
import navigateParams from '../../utils/navigation/navigateParams';
import { showSnackbar, showStopper } from '../../utils/store/features/user';
import BoxedRowList from '../BoxedRowList';
import './index.scss';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import useUserlight from '../../hooks/useUserLight';

export interface FiberConsumptionDataInterface {
    dataTab: any;
}

export const FiberConsumptionData: React.FC<FiberConsumptionDataInterface> = ({
    dataTab,
}: FiberConsumptionDataInterface) => {
    const isLight = useUserlight();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const storage = localStorage.getItem('storage');
    const consumptionsDisabled = managementEnvironment().VITE_STOPPER_CONSUMPTIONS_DISABLED;
    let storageJson: any;
    let voiceToPhone: any;
    let voiceToMobile: any;
    if (storage) {
        storageJson = JSON.parse(storage);
        voiceToPhone = storageJson.voiceToPhone;
        if (storageJson.voiceToMobile) {
            voiceToMobile = storageJson.voiceToMobile;
        }
    }

    const sendToNative = () => {
        if (isLight) {
            dispatch(showSnackbar());
        } else if (consumptionsDisabled) {
            dispatch(showStopper());
        } else {
            const productPsId: string = searchParams.get('productPsId')!;
            const type = 'modeFlow-backgroundBlue';
            const title = 'Detalle de consumo';
            const url = '/phone/consumption';
            const queryParams = { productPsId: productPsId };
            storageJson.isMobile = false;
            storageJson.detailType = 'VOICE';
            localStorage.setItem('storage', JSON.stringify(storageJson));
            if (navigateParams(type, url, queryParams, storageJson, title)) {
                navigate(url + '?productPsId=' + productPsId);
            }
        }
    };

    return (
        <div onClick={sendToNative}>
            <BoxedRowList
                title=''
                description=''
                asset=''
                headline={
                    voiceToPhone && (
                        <div className='FiberConsumptionData'>
                            <Text1 medium color={skinVars.colors.textSecondary}>
                                {t('landLineCalls')}
                            </Text1>
                            <div className='FiberConsumptionData__landlineCalls'>
                                <Text6>{formatTimeConsumption(voiceToPhone.current)}</Text6>
                                <div className='FiberConsumptionData__landlineCalls-limited'>
                                    <Text2 regular>
                                        {t('of')} {voiceToPhone.max === -1 ? t('unlimitedOnly') : voiceToPhone.max}
                                    </Text2>
                                </div>
                            </div>
                        </div>
                    )
                }
                extra={
                    voiceToMobile && (
                        <div className='FiberConsumptionData-mobile'>
                            <Text1 medium color={skinVars.colors.textSecondary}>
                                {t('mobileCalls')}
                            </Text1>
                            <div className='FiberConsumptionData-mobile__mobileCalls'>
                                <Text6>{formatTimeConsumption(voiceToMobile.current)}</Text6>
                                <div className='FiberConsumptionData-mobile__mobileCalls-limited'>
                                    <Text2 regular>
                                        {t('of')} {voiceToMobile.max === -1 ? t('unlimitedOnly') : voiceToMobile.max}
                                    </Text2>
                                </div>
                            </div>
                        </div>
                    )
                }
                handleSelection={() => {}}
            ></BoxedRowList>
        </div>
    );
};

export default FiberConsumptionData;
